import * as Sentry from '@sentry/browser'
import * as Integrations from "@sentry/integrations"
import Vue from "vue"

class SentryManager {
  constructor(dsn) {
    if (process.env.NODE_ENV === 'development') return;

    Sentry.init({
        dsn: dsn,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        tracesSampleRate: 0.1,
        integrations: [new Integrations.Vue({Vue, attachProps: true})],
    })
  }

  captureMessage(message, captureContext = 'info') {
    Sentry.captureMessage(message, captureContext)
  }

  captureException(exception, captureContext) {
    Sentry.captureException(exception, captureContext)
  }

  setUser(user) {
    Sentry.setUser(user)
  }

  setTag(key, value) {
    Sentry.setTag(key, value)
  }

  setExtra(key, value) {
    Sentry.setExtra(key, value)
  }

  addBreadcrumb(breadcrumb) {
    Sentry.addBreadcrumb(breadcrumb)
  }
}

export default SentryManager
